import { CartLineItemGiftDetails } from './CartLineItem';

export interface CartItem {
    productId: number;
    selectedOptions: { [optionId: number]: string };
    quantity: number;
    priceOverride: number | null;
    giftDetail?: CartLineItemGiftDetails;
}

export interface BulkOrderCartItem extends Omit<CartItem, 'giftDetail'> {
    giftDetails: CartLineItemGiftDetails[];
}

export const emptyCartItem: CartItem = {
    productId: 0,
    selectedOptions: {},
    quantity: 1,
    priceOverride: null,
};

export interface GiftDetail {
    fromName: string;
    fromPhone: string;
    toName: string;
    toEmail: string;
    deliveryDate: string;
    message: string;
    productImageName: string;
}
